<template>
	<div>
		<div class="discount-title" :class="{'discount-title-desktop': !isMobile && !sideMenuDiscount}">{{ $t('utilityComponents.productAsCompensationCRMModule.discounts') }}</div>
		<v-tabs
			v-model="active"
			color="black"
			dark
			slider-color="transparent"
			class="discount-tabs"
			:class="{'discount-tabs-desktop': !isMobile && !sideMenuDiscount, 'discount-side-menu': sideMenuDiscount}"
		>
			<v-tab href="#tab-1" :key="1">
				{{ $t('utilityComponents.productAsCompensationCRMModule.active') }}
			</v-tab>

			<v-tab href="#tab-2" :key="2">
				{{ $t('utilityComponents.productAsCompensationCRMModule.expired') }}
			</v-tab>

			<v-tab href="#tab-3" :key="3">
				{{ $t('utilityComponents.productAsCompensationCRMModule.used') }}
			</v-tab>
			<v-tab-item
				:key="1"
				:value="'tab-' + 1"
			>
				<v-card v-for="item in voucherAwardsActive" :key="item.voucherId" flat class="discount-product-wrapper">
					<div class="discount-product">
						<img class="discount-product-image" :src="getProductImage(item.product)">
						<div class="discount-product-name-price">
							<div>
								<div class="discount-card-product-name">{{ item.product.name }}</div>
								<div class="discount-card-product-discount">{{ item.percent === 100 ? $t('utilityComponents.productAsCompensationCRMModule.gratis') : item.percent + "% Discount"}}</div>
							</div>
							<div class="discount-price-section">
								<div class="discount-new-price">{{ item.percent === 100 ? $t('utilityComponents.productAsCompensationCRMModule.free') : item.percent + "%" }}</div>
							</div>
							<v-btn v-if="!isMobile && !sideMenuDiscount"
								@click="takeAward(item.product.id, item.voucherId)"
								:ripple="false"
								class="redeem-discount green-btn"
								primary
								flat>
								{{ $t('utilityComponents.productAsCompensationCRMModule.redeemDiscount') }}
							</v-btn>
						</div>
					</div>
					<div class="discount-product-footer">
						<v-btn v-if="isMobile || (!isMobile && sideMenuDiscount)"
							@click="takeAward(item.product.id, item.voucherId)"
							:ripple="false"
							class="redeem-discount green-btn"
							primary
							flat>
							{{ $t('utilityComponents.productAsCompensationCRMModule.redeemDiscount') }}
						</v-btn>
						<div class="discount-product-valid">
							{{ $t('utilityComponents.productAsCompensationCRMModule.discountValid') }} {{ voucherExpirationDate(item) }}
						</div>
					</div>
				</v-card>
			</v-tab-item>
			<v-tab-item
				:key="2"
				:value="'tab-' + 2"
				class="discount-expired"
			>
				<v-card v-for="item in voucherAwardsExpired" :key="item.voucherId" flat class="discount-product-wrapper">
					<div class="discount-product">
						<img class="discount-product-image" :src="getProductImage(item.product)">
						<div class="discount-product-name-price">
							<div>
								<div class="discount-card-product-name">{{ item.product.name }}</div>
								<div class="discount-card-product-discount">{{ item.percent === 100 ? $t('utilityComponents.productAsCompensationCRMModule.gratis') : item.percent + "% Discount"}}</div>
							</div>
							<div class="discount-price-section">
								<div class="discount-new-price">{{ item.percent === 100 ? $t('utilityComponents.productAsCompensationCRMModule.free') : item.percent + "%" }}</div>
							</div>
						</div>
					</div>
				</v-card>
			</v-tab-item>
			<v-tab-item
				:key="3"
				:value="'tab-' + 3"
				class="discount-used"
			>
				<v-card v-for="item in voucherAwardsUsed" :key="item.voucherId" flat class="discount-product-wrapper">
					<div class="discount-product">
						<img class="discount-product-image" :src="getProductImage(item.product)">
						<div class="discount-product-name-price">
							<div>
								<div class="discount-card-product-name">{{ item.product.name }}</div>
								<div class="discount-card-product-discount">{{ item.percent === 100 ? $t('utilityComponents.productAsCompensationCRMModule.gratis') : item.percent + "% Discount"}}</div>
							</div>
							<div class="discount-price-section">
								<div class="discount-new-price">{{ item.percent === 100 ? $t('utilityComponents.productAsCompensationCRMModule.free') : item.percent + "%" }}</div>
							</div>
						</div>
					</div>
				</v-card>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>

import {mapGetters} from "vuex";
import appConfig, {frequentlyUsedChannelEnum} from "../../../../appconfig";
import ProductProvider from "../../../../providers/ProductProvider";
import * as Util from "../../../../libraries/utils";
import {voucherValidationHelper} from "../../../../helper/VoucherValidationHelper";
import {voucherProductAddToCartGt2, addProductToCart} from "../../../../helper/VoucherProductHelper";
import { getProductSpecificDiscount } from "../../../../domains2/priceRules/priceRulesHelpers";

const TimeBox = appConfig.timeBoxImpl.timebox;
const TimeBoxFormats = appConfig.timeBoxImpl.Formats;

export default {
	name: "Discount",
	props: ["sideMenuDiscount", "onClose"],
	data() {
		return {
			active: null,
			userVouchers: [],
			voucherAwardsActive: [],
			voucherAwardsExpired: [],
			voucherAwardsUsed: []
		};
	},
	computed: {
		...mapGetters(["featureToggles", "tenantSettings", "globalSelectedShop", "isSubscribed", "productCatalog", "cartProducts", "userCrmVouchersAndMilestoneRewards"]),
		isMobile() {
			return appConfig.channelAlias() === frequentlyUsedChannelEnum.mobileApp || appConfig.channelAlias() === frequentlyUsedChannelEnum.mobileBrowser;
		}
	},
	async mounted() {
		const self = this;
		self.userCrmVouchersAndMilestoneRewards.forEach(x=> {
			self.userVouchers.push({...x});
		});
		const tempProductIds = new Set();
		const voucherIdDiscountInfoMapTemp = {};
		self.userVouchers.forEach(x => {
			/* [0] is to take only first voucher / product. Anyway, milestone reward price rules should have only one
			voucher and only one product per price rule **/
			const voucherId = x.voucherId;
			if (!voucherIdDiscountInfoMapTemp[voucherId]) {
				voucherIdDiscountInfoMapTemp[voucherId] = x;
			}
			tempProductIds.add(x.productPattern[0]);
		});
		const products = [];
		if (self.productCatalog) {
			for (const id of tempProductIds) {
				const product = self.productCatalog.productMap[id];
				if (product) {
					products.push(product);
				}
			}
		} else {
			if (tempProductIds.size) {
				products.push(...(await ProductProvider.getProducts({productIds: tempProductIds})));
			}
		}
		for (const voucherId in voucherIdDiscountInfoMapTemp) {
			const item = voucherIdDiscountInfoMapTemp[voucherId];
			const productId = item.productPattern[0];
			const product = products.find(x => x.id === productId);
			if (product) {
				item.discountPrice = self.getDiscountedProductPrice(item, product);
				item.product = product;
				item.percent = item.discountValue;
				const isUsed = self.isVoucherUsed(item);
				const isExpired = self.isExpired(item);
				if (!isUsed && !isExpired) {
					self.voucherAwardsActive.push(item);
				} else if (isUsed) {
					self.voucherAwardsUsed.push(item);
				} if (isExpired) {
					self.voucherAwardsExpired.push(item);
				}

			}
		}
	},
	methods: {
		async takeAward(productId, voucherId) {
			const self = this;
			const ids = self.userVouchers.map(x=>x.voucherId);
			const psWithVouchers = self.cartProducts.filter(x=>x.voucherId);
			if (psWithVouchers.find(x => ids.includes(x.voucherId))) {
				self.$store.commit("SET_GLOBAL_INFO_DIALOG", "utilityComponents.productAsCompensationCRMModule.onlyOneAppliedDiscountAllowed");
				return;
			}

			self.$store.commit("SET_VOUCHER_PRODUCT_ADD_TO_CART", {productId, voucherId: voucherId});
			if(self.isMobile) {
				await voucherProductAddToCartGt2(self);
			} else {
				if (self.featureToggles.newBasketPage && ((self.globalSelectedShop || {}).shopOptions || {}).enableNewBasketPage) {
					if (self.$route.path.includes("basket")) {
						await addProductToCart(self, productId, voucherId);
						await voucherValidationHelper(self, voucherId);
					} else {
						if (self.globalSelectedShop && self.productCatalog) {
							await addProductToCart(self, productId, voucherId);
							await voucherValidationHelper(self, voucherId);
							self.$router.push(`/basket`);
						} else {
							self.$router.push(`/shop-selection`);
						}
					}
				} else {
					if (self.$route.path.includes("category")) {
						await addProductToCart(self, productId, voucherId);
						await voucherValidationHelper(self, voucherId);
					} else {
						if (self.globalSelectedShop && self.productCatalog) {
							const categories = Util.getCategoriesByShopId(self.globalSelectedShop.id, self.productCatalog);
							self.$router.push(`/category/${categories[0].extId}`);
						} else {
							self.$router.push(`/shop-selection`);
						}
					}
				}
			}
			self.onClose && self.onClose();
		},
		getDiscountedProductPrice(item, product) {
			const price = product.price - getProductSpecificDiscount({price: product.price, discount: item });
			return price > 0 ? price : 0;
		},
		getProductImage(product) {
			return Util.getBackImages(product).slice(0, 1);
		},
		isVoucherUsed(item) {
			return item.usedAt;
		},
		isExpired(item) {
			const voucherDate = this.voucherExpirationDate(item);
			if(voucherDate) {
				return TimeBox.fromISO(voucherDate).format(TimeBoxFormats.YYYY_MM_DD).exec() < TimeBox.now().format(TimeBoxFormats.YYYY_MM_DD).exec();
			}
			return false;
		},
		voucherExpirationDate(voucherItem) {
			return voucherItem.expiryDate;
		}
	}
};
</script>
<style scoped lang="scss">
.discount-title {
	font-size: 21px;
	color: white;
	text-align: center;
	text-transform: uppercase;
	line-height: 21px;
	margin: 15px 0 20px;
	&.discount-title-desktop {
		text-transform: none;
		font-size: 40px;
		text-align: start;
		font-weight: bold;
	}
}
.discount-tabs {
	margin: 15px 15px 80px;
	/deep/ .v-tabs__wrapper {
		margin-bottom: 15px;
		.v-tabs__div {
			width: 100%;
			background-color: #1A1B1E;
			text-transform: none;
			font-weight: bold;
		}
		.v-tabs__div:nth-child(3) {
			margin: 0 10px;
		}
	}
	/deep/ .v-tabs__item.v-tabs__item--active {
		border: 2px solid #FFD800;
	}
	.discount-product-wrapper {
		background-color: #1A1B1E !important;
		padding: 10px;
		margin-bottom: 15px;
		.discount-product {
			display: flex;
			.discount-product-image {
				width: 110px;
				height: 110px;
			}
			.discount-product-name-price {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				width: 100%;
				padding-left: 10px;
				.discount-card-product-name {
					font-size: 18px;
					color: #ffffff;
					font-weight: bold;
				}
				.discount-card-product-discount {
					font-size: 14px;
					color: #FFD800;
					font-weight: bold;
				}
				.discount-price-section {
					display: flex;
					.discount-regular-price {
						background-color: #333333;
						font-size: 20px;
						color: #7B7B7B;
						padding: 7px 15px;
						line-height: 1;
						text-decoration: line-through;
						font-weight: bold;
					}
					.discount-new-price {
						background-color: #FFD800;
						font-size: 20px;
						font-weight: bold;
						padding: 7px 15px;
						line-height: 1;
						text-transform: uppercase;
					}
				}
			}
		}
		.discount-product-footer {
			margin-top: 15px;
			.discount-product-valid {
				color: #9B9B9B;
				padding-top: 12px;
			}
		}
	}
	.discount-expired, .discount-used {
		.discount-product-wrapper .discount-product .discount-product-name-price {
			.discount-card-product-discount {
				color: #7B7B7B;
			}
			.discount-price-section .discount-new-price {
				background-color: #7B7B7B;
			}
		}
	}
	&.discount-tabs-desktop {
		margin: 0;
		height: calc(100vh - 200px);
		overflow-y: auto;
		.discount-product-wrapper {
			.discount-product {
				.discount-product-name-price {
					flex-direction: row;
					flex-wrap: wrap;
				}
				.discount-price-section {
					align-items: flex-start;
				}
				.discount-product-image {
					width: 150px;
					height: 150px;
				}
				.redeem-discount {
					align-self: flex-end;
					margin: 0;
					height: 50px;
				}
				.discount-new-price {
					text-transform: uppercase;
					color: #000000;
				}
			}
			.discount-product-footer {
				.discount-product-valid {
					padding-top: 0;
					text-align: right;
				}
			}
		}
	}
	&.discount-side-menu {
		.redeem-discount.green-btn {
			height: 50px;
			margin: 0;
		}
		.discount-price-section {
			justify-content: flex-end;
			color: #000000;
		}
	}
}
</style>

